<template>
    <div v-if="!loadingPage">
        <select-shop :loadingButton="!loadingButton" v-on:getData="getPromotion"></select-shop>
        <div v-if="isPermission">
            <CCard  class="shadow-sm">
                <CCardBody  class="p-4">

                    <!-- ═══ HEADER ═══ -->
                    <div class="promo-header">
                        <div class="promo-header-left">
                            <h2 class="promo-title">
                                <i class="fi fi-rr-badge-percent mr-2"></i>{{ $t('promotion') }}
                            </h2>
                            <!-- <show-date></show-date> -->
                        </div>
                        <div class="promo-header-right">
                            <CButton to="/promotion/template" color="success" class="promo-btn-create">
                                <i class="fi fi-rr-plus mr-1"></i>{{ $t("createPromotion") }}
                            </CButton>
                            <CButton color="primary" variant="outline" class="promo-btn-sort"
                                @click="$router.push('/promotion/sort')">
                                <i class="fi fi-rr-sort-alt mr-1"></i>
                                {{ $t('sortPriority') || 'จัดเรียงระดับความสำคัญ' }}
                            </CButton>
                        </div>
                    </div>

                    <!-- ═══ SUMMARY STATS ═══ -->
                    <!-- <div class="promo-stats">
                        <div class="promo-stat-item" :class="{ 'promo-stat-item--selected': statusFilter === 'all' }" @click="changeStatusFilter('all')" style="cursor:pointer;">
                            <div class="promo-stat-num">{{ promotions.length }}</div>
                            <div class="promo-stat-label">{{ $t('allPromotion') || 'ทั้งหมด' }}</div>
                        </div>
                        <div class="promo-stat-item promo-stat-item--active" :class="{ 'promo-stat-item--selected': statusFilter === 'active' }" @click="changeStatusFilter('active')" style="cursor:pointer;">
                            <div class="promo-stat-num">{{ activeCount }}</div>
                            <div class="promo-stat-label">{{ $t('promotionActive') || 'ใช้งานอยู่' }}</div>
                        </div>
                        <div class="promo-stat-item promo-stat-item--expired" :class="{ 'promo-stat-item--selected': statusFilter === 'expired' }" @click="changeStatusFilter('expired')" style="cursor:pointer;">
                            <div class="promo-stat-num">{{ expiredCount }}</div>
                            <div class="promo-stat-label">{{ $t('promotionExpired') || 'หมดอายุ' }}</div>
                        </div>
                    </div> -->

                    <!-- ═══ FILTER TABS ═══ -->
                    <div class="promo-filters">
                        <div class="promo-status-tabs">
                            <button class="promo-tab" :class="{ 'promo-tab--active': statusFilter === 'all' }"
                                @click="changeStatusFilter('all')">
                                <i class="fi fi-rr-layers mr-1"></i>
                                {{ $t('viewAllFood') || 'ทั้งหมด' }}
                            </button>
                            <button class="promo-tab" :class="{ 'promo-tab--active': statusFilter === 'not_expired' }"
                                @click="changeStatusFilter('not_expired')">
                                <i class="fi fi-rr-check-circle mr-1"></i>
                                {{ $t('promotionNotExpired') || 'ยังไม่หมดอายุ' }}
                            </button>
                            <button class="promo-tab" :class="{ 'promo-tab--active': statusFilter === 'active' }"
                                @click="changeStatusFilter('active')">
                                <i class="fi fi-rr-play-circle mr-1"></i>
                                {{ $t('promotionActive') || 'เปิดใช้งาน' }}
                            </button>
                            <button class="promo-tab" :class="{ 'promo-tab--active': statusFilter === 'inactive' }"
                                @click="changeStatusFilter('inactive')">
                                <i class="fi fi-rr-pause-circle mr-1"></i>
                                {{ $t('promotionNotActive') || 'ปิดใช้งาน' }}
                            </button>
                            <button class="promo-tab promo-tab--expired-btn"
                                :class="{ 'promo-tab--active-expired': statusFilter === 'expired' }"
                                @click="changeStatusFilter('expired')">
                                <i class="fi fi-rr-calendar-xmark mr-1"></i>
                                {{ $t('promotionExpired') || 'หมดอายุแล้ว' }}
                            </button>
                        </div>
                        <div class="promo-type-filter">
                            <select v-model="selectedType" class="custom-select custom-select-sm">
                                <option value="all">{{ $t("viewAllFood") || 'ประเภททั้งหมด' }}</option>
                                <option v-for="option in discountOptions" :key="option.value" :value="option.value">
                                    {{ $t(option.label) }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div v-if="!loading">
    
                        <!-- ═══ PROMOTION CARDS ═══ -->
                        <div v-if="sortedPromotions.length > 0" class="promo-grid">
                            <div v-for="promotion in promotions" :key="promotion.objectId"
                                @click="showDetail(promotion.objectId)"
                                class="promo-card-wrapper"
                                :class="{ 'promo-card-wrapper--expired': isExpired(promotion) }">
                                <div class="promo-card">
                                    <!-- Badges -->
                                    <div class="promo-card-badges">
                                        <span v-if="promotion.isActive && !isExpired(promotion)" class="promo-badge promo-badge--active">
                                            <i class="fi fi-rr-dot-circle"></i> {{ $t('promotionActive') }}
                                        </span>
                                        <span v-else-if="!promotion.isActive && !isExpired(promotion)" class="promo-badge promo-badge--inactive">
                                            <i class="fi fi-rr-dot-circle"></i> {{ $t('promotionNotActive') }}
                                        </span>
                                        <span v-if="isExpired(promotion)" class="promo-badge promo-badge--expired">
                                            <i class="fi fi-rr-calendar-xmark"></i> {{ $t('promotionExpired') }}
                                        </span>
                                        <span v-if="isGrabPromotion(promotion)" class="promo-badge promo-badge--grab">
                                            <img width="48px" src="/img/grabFood.svg">
                                        </span>
                                    </div>

                                    <!-- Usage Count -->
                                    <div v-if="promotion.usageCount && promotion.usageCount > 0" class="promo-card-usage">
                                        <i class="fi fi-rr-receipt"></i>
                                        {{ $t('usedPromotionBadge') }} {{ promotion.usageCount }} {{ $t('usedPromotionBadgeDesp') }}
                                    </div>

                                    <!-- Image -->
                                    <div class="promo-card-img">
                                        <img :src="promotion.details.remoteImagePath || 'https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png'"
                                            @error="$event.target.src = 'https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png'" />
                                        <!-- Expired overlay -->
                                        <div v-if="isExpired(promotion)" class="promo-card-expired-overlay">
                                            <span>{{ $t('promotionExpired') || 'หมดอายุ' }}</span>
                                        </div>
                                    </div>

                                    <!-- Info -->
                                    <div class="promo-card-info">
                                        <h5 class="promo-card-title limited-text-one">{{ promotion.details.title }}</h5>
                                        <div class="promo-card-meta">
                                            <div class="promo-card-meta-row">
                                                <i class="fi fi-rr-badge-percent"></i>
                                                <span>{{ $t(promotion.type) }}</span>
                                            </div>
                                            <div class="promo-card-meta-row">
                                                <i class="fi fi-rr-comment-question"></i>
                                                <span>{{ $t(promotion.condition.type) }}</span>
                                            </div>
                                            <div class="promo-card-meta-row promo-card-date">
                                                <i class="fi fi-rr-calendar-clock"></i>
                                                <span>{{ parseISODate(promotion.startDate) }} {{ $t('to') }} {{ parseISODate(promotion.endDate) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- ═══ EMPTY FILTERED ═══ -->
                        <div v-else class="promo-empty-filter">
                            <i class="fi fi-rr-search-alt" style="font-size: 32px; color: #ccc;"></i>

                                <div class="empty-title">{{ $t('emptyPromotionTitle') }}</div>
                                <div class="empty-desc">{{ $t('emptyPromotionDesp') }}</div>
                                <CButton color="primary" size="sm" class="mt-3" to="/promotion/template" >
                                    + {{ $t('createPromotion') }}
                                </CButton>
                    
                        </div>
                        <br/>
                        <pagination :meta_data="meta_data" v-on:next="getPromotion"></pagination>
                    </div>
                    <div v-if="loading"  class="p-5">
                        <div style="width: 100%; min-height: 30vh; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 16px;">
                            <div style="position: relative; width: 48px; height: 48px;">
                                <div style="width: 48px; height: 48px; border: 4px solid #f0f0f0; border-top: 4px solid #2eb85c; border-radius: 50%; animation: promotionSpin 0.8s linear infinite;"></div>
                                <i class="fi fi-rr-ticket" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 1rem; color: #2eb85c;"></i>
                            </div>
                            <div class="text-center">
                                <div style="color: #888; font-size: 0.88rem;">{{ $t('loadingPromotion') }}</div>
                            </div>
                        </div>
                    </div>
                </CCardBody>

                <!-- ═══ EMPTY STATE (no promotions at all) ═══ -->
                <!-- <CCardBody v-else>
                  
                </CCardBody> -->
            </CCard>

            <!-- ═══ LOADING ═══ -->
            <!-- <CCard v-if="loading" class="shadow-sm">
                <CCardBody class="p-5">
                    <div style="width: 100%;height: 100vh;display: flex;justify-content: center;">
                        <CSpinner color="success"></CSpinner>
                    </div>
                </CCardBody>
            </CCard> -->

            <!-- Help Modal -->
            <CModal :show.sync="openHelpModal" centered :title="$t('userManual')" color="success" header="false" size="lg">
                <template #footer>
                    <CRow class="justify-content-around col-md-12">
                        <CCol col="4">
                            <CButton @click="openHelpModal = false" color="outline-success" block>
                                <b>{{ $t("submit") }}</b>
                            </CButton>
                        </CCol>
                    </CRow>
                </template>
            </CModal>
        </div>

        <!-- ═══ NO PERMISSION ═══ -->
        <div v-else>
            <CCard class="shadow-sm">
                <CCardBody>
                    <div>
                        <div class="row w-100 p-4 text-center">
                            <div class="col-md-12 col-sm-12">
                                <div class="text-center w-100">
                                    <h3 class="mb-3">{{ $t('promotionHeaderEmpty') }} <CBadge color="success">new</CBadge></h3>
                                    <div>
                                        <span style="line-height: 220%; color: gray">{{ $t('forGrabPackage') }}</span><br>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row w-100 pl-4 pr-4">
                            <div v-for="(feature, index) in keyFeatures" :key="'feat2-' + index" class="col-md-4 col-sm-12 p-2">
                                <div class="feature-box">
                                    <div class="p-4 text-left">
                                        <h1 v-if="index !== 0"><i :class="feature.icon"></i></h1>
                                        <h1 v-else><img width="140px" src="/img/grabFoodWhite.svg"></h1>
                                        <span class="text-left" style="font-size: 16px;">
                                            {{ $t(`promotionFeatures[${index}].description` || '') }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span class="w-100 text-center mt-2" style="color: gray;">* {{ $t('promotionHeaderEmptyDesp') }}</span>
                    </div>
                </CCardBody>
            </CCard>
        </div>
    </div>
    <div v-else>
        <CCard class="shadow-sm">
            <CCardBody>
                <div style="width: 100%; min-height: 50vh; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 20px;">
                    <div style="position: relative; width: 56px; height: 56px;">
                        <div style="width: 56px; height: 56px; border: 4px solid #f0f0f0; border-top: 4px solid #2eb85c; border-radius: 50%; animation: promotionSpin 0.8s linear infinite;"></div>
                        <i class="fi fi-rr-ticket" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 1.2rem; color: #2eb85c;"></i>
                    </div>
                    <div class="text-center">
                        <div style="color: #333; font-weight: 500; font-size: 0.95rem;">{{ $t('loadingPromotion') }}</div>
                        <div style="color: #aaa; font-size: 0.82rem; margin-top: 4px;">{{ $t('loadingPleaseWait') }}</div>
                    </div>
                </div>
            </CCardBody>
        </CCard>
    </div>
</template>


<script>
import { mapGetters } from 'vuex'
import permis from '@/util/permission'
import pos from '@/services/local'
import moment from 'moment'
import '@/assets/styles/promotion.css'
import util from '@/util/util'
import Pagination from '@/containers/Pagination'

export default {
    components: {
        Pagination
    },
    data() {
        return {
            loadingButton: false,
            openHelpModal: false,
            promotions: [],
            selectedType: 'all',
            statusFilter: 'all',
            discountOptions: [
                { value: "ITEM_FIXED_PRICE", label: "ITEM_FIXED_PRICE" },
                { value: "CATEGORY_FIXED_PRICE", label: "CATEGORY_FIXED_PRICE" },
                { value: "ITEM_PERCENTAGE_DISCOUNT", label: "ITEM_PERCENTAGE_DISCOUNT" },
                { value: "ITEM_DOLLAR_DISCOUNT", label: "ITEM_DOLLAR_DISCOUNT" },
                { value: "CATEGORY_PERCENTAGE_DISCOUNT", label: "CATEGORY_PERCENTAGE_DISCOUNT" },
                { value: "CATEGORY_DOLLAR_DISCOUNT", label: "CATEGORY_DOLLAR_DISCOUNT" },
                { value: "RECEIPT_PERCENTAGE_DISCOUNT", label: "RECEIPT_PERCENTAGE_DISCOUNT" },
                { value: "RECEIPT_DOLLAR_DISCOUNT", label: "RECEIPT_DOLLAR_DISCOUNT" },
                { value: "ITEM_X_FREE_Y", label: "ITEM_X_FREE_Y" },
                { value: "CATEGORY_X_FREE_Y", label: "CATEGORY_X_FREE_Y" },
                { value: "FREE_ITEM", label: "FREE_ITEM" }
            ],
            keyFeatures: [
                { icon: 'fi fi-rr-magic-wand' },
                { icon: 'fi fi-rr-magic-wand' },
                { icon: 'fi fi-rr-magic-wand' },
                { icon: 'fi fi-rr-layers' },
                { icon: 'fi fi-rr-clock ' },
                { icon: 'fi fi-rr-tally  ' },
            ],
            loading: false,
            orderShopSetting: {},
            loadingPage: false,
            meta_data: {
                last_page: null,
                current_page: 1,
                prev_page_url: null,
                items: 0,
                limit: null,
                itemCount: null,
            },
        }
    },
    computed: {
        ...mapGetters(['shops', 'users', 'date', 'permissions']),
        isPermission() {
            const shopObjectId = localStorage.getItem('shopObjectId');
            const selectedShop = this.shops.find(shop => shop.objectId === shopObjectId) || null
            let isSilomPromotionEnabled = this.orderShopSetting?.promotionSetting?.enabled || false
            let isEnabled = this.orderShopSetting?.isGrabOrderEnabled == true || isSilomPromotionEnabled
            return isEnabled
        },
        shopObjectId: {
            get() {
                return this.$store.getters.shopObjectId
            },
        },
        uid() {
            return localStorage.getItem('uid')
        },
        activeCount() {
            return this.promotions.filter(p => p.isActive && !this.isExpired(p)).length
        },
        expiredCount() {
            return this.promotions.filter(p => this.isExpired(p)).length
        },
        notExpiredCount() {
            return this.promotions.filter(p => !this.isExpired(p)).length
        },
        sortedPromotions() {
            const currentDate = new Date();
            let filtered = this.promotions;

            // Sort only — status & type are already filtered by API
            return filtered.sort((a, b) => {
                const aExpired = this.isExpired(a);
                const bExpired = this.isExpired(b);

                if (aExpired && !bExpired) return 1;
                if (!aExpired && bExpired) return -1;

                return new Date(b.created_at) - new Date(a.created_at);
            });
        },
        isGrabOrderEnabled() {
            return this.orderShopSetting?.isGrabOrderEnabled || false
        }
    },
    created() {
        this.getPromotion()
        this.getOrderShopSetting()
    },
    methods: {
        changeStatusFilter(status) {
            this.statusFilter = status
            this.getPromotion()
        },
        getPromotion(page = 1) {
            this.loading = true
            const headers = {
                shopObjectId: util.sanitizeShopObjectId(this.shopObjectId),
                uid: this.uid,
            }

            const params = {
                status: this.statusFilter || 'all',
                type: this.selectedType || 'all',
                sortattr: 'created_at',
                sortorder: 'desc',
                page: page,
                limit: 20,
            }

            // // เพิ่ม date range filter
            // if (this.date && this.date.start && this.date.end) {
            //     params.startAt = moment(String(this.date.start)).format('YYYY-MM-DD')
            //     params.endAt = moment(String(this.date.end)).format('YYYY-MM-DD')
            // }

            pos
                .get(`/api/v3.0/shop/promotions/${this.shopObjectId}`, {
                    headers: headers,
                    params: params
                })
                .then((res) => {
                    this.promotions = res.data?.data || []
                     if (res.data.paginate.items == undefined) {
                        this.meta_data.items = 0
                    } else {
                        this.meta_data.items = res.data.paginate.items
                    }
                    this.meta_data.last_page = res.data.paginate.pageCount
                    this.meta_data.current_page = res.data.paginate.currentPage
                    this.meta_data.itemCount = res.data.paginate.itemCount
                    this.meta_data.limit = res.data.paginate.perPage
                    this.loading = false
                })
                .catch((error) => {
                    this.loading = false
                });
        },
        parseISODate(isoDate) {
            const date = new Date(isoDate);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${day}/${month}/${year}, ${hours}:${minutes}`;
        },
        showDetail(objectId) {
            this.$router.push(`/promotion/details/${objectId}`)
        },
        isExpired(promotion) {
            const currentDate = new Date();
            const endDate = new Date(promotion.endDate);
            return currentDate > endDate;
        },
        isGrabPromotion(promotion) {
            return promotion.scopes && promotion.scopes.includes('GRAB')
        },
        getOrderShopSetting() {
            this.loadingPage = true
            const uid = this.uid
            let params = {
                shopObjectId: this.shopObjectId,
            }
            pos({
                method: 'get',
                url: '/api/v2.0/' + uid + '/OrderShopSetting',
                params: params,
                headers: { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId) }
            }).then((res) => {
                this.orderShopSetting = res?.data?.data[0] || null
                this.loadingPage = false
            })
        },
        getSuggestPromotionTitle(type, results) {
            const title = util.generatePromotionResultTitle(type, results)
            return title
        },
        getSuggestPromotionDescription(condition) {
            const description = util.generatePromotionConditionTitle(condition)
            return description
        }
    },
    watch: {
        shopObjectId(newVal, oldVal) {
            this.getPromotion()
            this.getOrderShopSetting()
        },
        selectedType() {
            this.getPromotion()
        },
        date: {
            handler() {
                this.getPromotion()
            },
            deep: true
        },
    },
}
</script>
<style>
@keyframes promotionSpin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
